import React from "react";

import List from "src/pages/report/list";
import List_Sum from "src/pages/report/report_sum";
import Header from "src/pages/report/header";

import { usePlanContext } from "src/contexts/planContext";

const Index = () => {
  const { state, dispatch } = usePlanContext();
  console.log(state.report.type);
  return (
    <div className=" p-2 text-xs">
      <Header />
      {state.report.type === "cash" ? <List /> : <List_Sum />}
      {/* <List /> */}
      {/* <Header />
      <div className="flex flex-col md:flex-row gap-2 ">
        {state.single_page ? (
          <div className="md:w-2/3">
            {" "}
            <WorkersType />{" "}
          </div>
        ) : (
          <Type />
        )}

        <div className="md:w-2/3">{state.single_page ? <Workers /> : ""}</div>
      </div> */}
    </div>
  );
};

export default React.memo(Index);
